<template>
  <div class="flex gap-2 mb-2.5 bg-base-200 p-2.5 rounded-md">
    <div class="flex items-center flex-col">
      <UserAvatar
        class="w-10"
        :avatar-url="mateStore.mateIdMap.get(character.mateId)?.mediaUrl"
      />
      <div
        class="text-xs text-base-content/50 w-10 text-center overflow-hidden line-clamp-1"
      >
        {{
          character.role === 2
            ? $t("game.player")
            : mateStore.mateIdMap.get(character.mateId)?.name
        }}
      </div>
      <div @click="clickAddTarget()" v-if="character.targetzz?.length !== 0">
        <button class="btn btn-xs btn-ghost text-base-content/50">
          <i class="iconify mingcute--edit-3-line text-xs" />
        </button>
      </div>
    </div>

    <div v-if="character.targetzz?.length === 0">
      <div class="text-xs text-base-content/50 mb-2">
        {{ $t("Chats.chatScene.edit.noTarget") }}
      </div>

      <button
        class="btn btn-xs btn-neutral text-base-content/50 gap-0"
        @click="clickAddTarget()"
      >
        <i class="iconify mdi--plus text-xs" />
        {{ $t("Buttons.add") }}
      </button>
    </div>
    <div v-else class="flex-1">
      <div v-if="winTarget">
        <p class="text-[#00DA39] text-xs">
          {{
            $t("Chats.chatScene.edit.winning") +
            " " +
            $t("Chats.chatScene.edit.condition")
          }}
        </p>

        <div class="justify-center items-center text-xs text-center">
          <div class="flex gap-2 w-full text-base-content/50">
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.character") }}
            </div>
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.attr") }}
            </div>
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.condition") }}
            </div>
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.value") }}
            </div>
          </div>

          <div class="flex gap-2 w-full text-base-content/50">
            <div v-if="winTarget.targetCharacterId" class="flex-1 line-clamp-1">
              {{
                mateStore.mateIdMap.get(winTarget.targetCharacter?.mateId!)
                  ?.name || $t("game.player")
              }}
            </div>
            <div class="flex-1 line-clamp-1">
              {{
                chatScene.scorezz?.find((s) => s.id === winTarget!.scoreId)
                  ?.name
              }}
            </div>
            <div class="flex-1">
              {{ winTarget.targetOperator }}
            </div>
            <div class="flex-1">
              {{ winTarget.targetScore }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="failTarget">
        <VanDivider class="my-2" />
        <p class="text-error text-xs">
          {{
            $t("Chats.chatScene.edit.losing") +
            " " +
            $t("Chats.chatScene.edit.condition")
          }}
        </p>

        <div class="justify-center items-center text-xs text-center">
          <div class="flex gap-2 w-full text-base-content/50">
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.character") }}
            </div>
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.attr") }}
            </div>
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.condition") }}
            </div>
            <div class="flex-1">
              {{ $t("Chats.chatScene.edit.value") }}
            </div>
          </div>

          <div class="flex gap-2 w-full text-base-content/50">
            <div
              v-if="failTarget.targetCharacterId"
              class="flex-1 line-clamp-1"
            >
              {{
                mateStore.mateIdMap.get(failTarget.targetCharacter?.mateId!)
                  ?.name || $t("game.player")
              }}
            </div>
            <div class="flex-1 line-clamp-1">
              {{
                chatScene.scorezz?.find((s) => s.id === failTarget!.scoreId)
                  ?.name
              }}
            </div>
            <div class="flex-1">
              {{ failTarget.targetOperator }}
            </div>
            <div class="flex-1">
              {{ failTarget.targetScore }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalChatSceneCharacterTarget
      v-model:show="showTargetModal"
      :character="character"
      :chat-scene="chatScene"
    />
  </div>
</template>

<script setup lang="ts">
import { ChatSceneTargetType, MateCardPromptType } from "@/enums/chatEnums";
import { useMate } from "@/stores/mate";
import {
  ChatScene,
  ChatSceneCharacter,
  ChatSceneCharacterTarget,
} from "@/types/chat";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const mateStore = useMate();
const { t } = useI18n();
const props = defineProps<{
  chatScene: ChatScene;
  character: ChatSceneCharacter;
}>();

const emit = defineEmits<{
  (e: "update:save"): void;
  (e: "update:target", target: ChatSceneCharacterTarget): void;
}>();

const winTarget = computed(() => {
  return props.character.targetzz?.find(
    (target) => target.type === ChatSceneTargetType.WINNING
  );
});

const failTarget = computed(() => {
  return props.character.targetzz?.find(
    (target) => target.type === ChatSceneTargetType.LOSING
  );
});

const showTargetModal = ref(false);

const clickAddTarget = () => {
  showTargetModal.value = true;
};
</script>
